import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import NavBar from './NavBar';
import Footer from './Footer';
import ScrollNav from './ScrollNav';
import SideAvatar from './SideAvatar';
import BundleFlyout from './BundleFlyout';
import ExitIntentPopup from './ExitIntentPopup';
import { useLang } from '../LangContext';
import useSmoothScroll from '../hooks/useSmoothScroll';

/**
 * Layout — shared chrome for every routed page.
 *
 *   <NavBar /> + <main>{children}</main> + <Footer />
 *
 * Plus the persistent floating UI: ScrollNav (top/bottom buttons) and
 * SideAvatar (Marco — desktop only).
 *
 * Scrolls to top on every route change so users start each page at the top.
 */
export default function Layout({ children }) {
  const { c } = useLang();
  const location = useLocation();
  useSmoothScroll();

  useEffect(() => { window.scrollTo(0, 0); }, [location.pathname]);

  return (
    <div className="App relative" data-testid="app-root">
      <NavBar />
      <main>{children}</main>
      <Footer />
      <SideAvatar {...c.advisor} />
      <BundleFlyout />
      <ScrollNav />
      <ExitIntentPopup />
    </div>
  );
}
